import React from 'react';

function ConnectForm() {
    return <div>ConnectForm</div>;
}

export default ConnectForm;
